module.exports = __webpack_public_path__ + "static/media/default-video.be9f29a2.png";